export default __webpack_public_path__ + "static/media/instagram-inactive.d9602018.svg";